import React from "react"

const FeedbackQuestion = (props) => {
  const {
    question,
    setQuestion,
    children,
    currentAnswerValue,
    onChangeHandler,
  } = props

  const isValidElement = React.isValidElement(React.Children.only(children))
  setQuestion(question)

  return (
    <div>
      <div className="feedback-question">{question}</div>

      {isValidElement
        ? React.cloneElement(children, {
            onChangeHandler,
            currentAnswerValue,
          })
        : null}
    </div>
  )
}

export default FeedbackQuestion
